/* eslint no-console: 0, no-native-reassign: 0, no-undef: 0, camelcase: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { GuestStatus, HostStatus } from './data/booking-status-data';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

export const CheckBookingState = (props) => {
  const { view_as, obj_state, cancelled_by, review , contractData} = props;
  const masterContract = _.find(contractData, contract => contract.master);
  // Check if obj_state is in current list of states
  const checkStatus = 'HOST' === view_as ?
    HostStatus().hasOwnProperty(obj_state) :
    GuestStatus().hasOwnProperty(obj_state);
  const isFraudNoAuth = _.get(masterContract, 'metadata.fc_rejection', false);
  // If not in current list of states will default to 'NO_STATE' view
  switch (obj_state) {
  case 'EXECUTED':
    if (!review.complete) {
      return 'EXECUTED.leave_review';
    }
    return 'EXECUTED.completed';
  case 'SETTLED':
    if (!review.complete) {
      return 'EXECUTED.leave_review';
    }
    return 'EXECUTED.completed';
  case 'UNDER_REVIEW':
    if ('ADMIN' === cancelled_by) {
      return 'UNDER_REVIEW_ADMIN';
    }
    if (('GUEST' === view_as) && ('HOST' === cancelled_by)) {
      return 'UNDER_REVIEW_HOST';
    }
    return 'UNDER_REVIEW';
  case 'CANCELLED':
    if ('GUEST' === view_as) {
      if ('GUEST' === cancelled_by) {
        return 'CANCELLED.cancelled_by_guest';
      } else if ('ADMIN' === cancelled_by) {
        return 'CANCELLED.cancelled_by_admin';
      }
      return 'CANCELLED.cancelled_by_host';
    } else if ('HOST' === view_as) {
      if ('HOST' === cancelled_by) {
        return 'CANCELLED.cancelled_by_host';
      } else if ('ADMIN' === cancelled_by) {
        return 'CANCELLED.cancelled_by_admin';
      }
      return 'CANCELLED.cancelled_by_guest';
    }
    return 'CANCELLED.cancelled_by_guest';
  case 'HOST_UPDATE_REQUESTED':
    return 'UPDATE_REQUESTED.update_requested_by_host';
  case 'GUEST_UPDATE_REQUESTED':
    return 'UPDATE_REQUESTED.update_requested_by_guest';
  case 'GUEST_UPDATE_NO_AUTH':
    return 'UPDATE_REQUESTED.update_requested_by_guest_no_auth';
  case 'HOST_UPDATE_NO_CAPTURE':
    return 'UPDATE_REQUESTED.update_requested_by_host_no_auth';
  case 'ACTIVE':
    return 'ACCEPTED';
  case 'NO_AUTH':
    return isFraudNoAuth ? 'FC_NO_AUTH' : 'NO_AUTH';
  case 'OFFER_NO_CAPTURE':
    return isFraudNoAuth ? 'FC_NO_AUTH' : 'OFFER_NO_CAPTURE';
  default:
    if (!checkStatus) {
      return 'NO_STATE';
    }
    return obj_state;
  }
};

export const GetStatus = (props, context) => {
  const {
    name,
    user,
    bundleUpdateRequest,
    reviewCb,
    details,
    iosWebView,
    guestCanUpdate,
    updatedDetails,
    canInstantBook,
    hostCanUpdate,
    cancelUpdateDetails,
    accessToken,
    dispatch,
    hasNoContracts,
    iosConcierge,
    redirectOnReviewSuccess,
    contractData,
    inviteCreated
  } = props;
  const {
    view_as,
    booking_id,
    listing,
    pid,
    review,
    space,
    credit_amount_issued
  } = details;

  const { listing_id, country } = listing;
  const { review_id } = review;
  const bookingState = CheckBookingState({...details, contractData});
  const hostView = 'HOST' === view_as;
  const expires_in = (updatedDetails || {}).expires_in || details.expires_in;
  const showCancellationSummary = !_.isEmpty(cancelUpdateDetails) && (!cancelUpdateDetails.is_old_policy_cancel || cancelUpdateDetails.is_full_refund);
  const hasInventoryItems = _.get(space, 'has_inventory_items', false);
  const locale = SharedIntlProviderHOC.getLocale();
  const showReferralBanner = ('US' === country && 'en-US' === locale);
  const status = hostView ?
    _.get(HostStatus(name, expires_in, user, booking_id, bundleUpdateRequest, listing_id, pid, review_id, reviewCb, details, context, iosWebView, hostCanUpdate, canInstantBook, showCancellationSummary, accessToken, hasNoContracts, dispatch), bookingState)
    : _.get(GuestStatus(name, expires_in, user, booking_id, bundleUpdateRequest, listing_id, pid, review_id, reviewCb, details, context, iosWebView, guestCanUpdate, canInstantBook, showCancellationSummary, hasNoContracts, accessToken, iosConcierge, hasInventoryItems, credit_amount_issued, showReferralBanner, redirectOnReviewSuccess, inviteCreated), bookingState);
  return status;
};

export class BookingStatus extends React.Component {
  render () {
    const { children } = this.props;
    const status = GetStatus(this.props, this.context);
    return React.cloneElement(children, { status });
  }
}

BookingStatus.contextTypes = {
  router: PropTypes.object
};

BookingStatus.propTypes = {
  name: PropTypes.string,
  user: PropTypes.object,
  expires_in: PropTypes.object,
  view_as: PropTypes.string,
  children: PropTypes.object,
  booking_id: PropTypes.string,
  bundleUpdateRequest: PropTypes.func,
  listing: PropTypes.object,
  pid: PropTypes.string,
  review: PropTypes.object,
  reviewCb: PropTypes.func,
  context: PropTypes.object,
  redirectOnReviewSuccess: PropTypes.bool
};
